export default __webpack_public_path__ + "static/media/receptionmain.66074110.jpg";